import React, { Component } from 'react';
import Select from 'react-select';
import { Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import { toast } from 'react-toastify';

import { CustomCard } from "../../components/Card/CustomCard";

import { RegistraUsuario, BuscaUsuario, EditarUsuario } from "../../funciones/UsuariosFunctions";

let idUsuario= null;
let statusBtn = 0;
class Usuarios extends Component {
    state = {
        title: "¿Qué es esto?",
        string: "",
        preloader: "",
        button: {
            Icon:"pe-7s-add-user",
            Title:"Registrar"
        },
        selectedOption: {
            value: '1',
            label: 'Estudiante'
        },
        user:"",
        pass1:"",
        pass2:"",
        selectedOptionDisabled: false,
        pass1Disabled: false,
        pass2Disabled: false,
        boton2: { Icon:"fa fa-times", Title:""},
        boton3: { Icon:"fa fa-edit", Title:""},
    }

    handleChange = (selectedOption) => {
        this.setState({
            selectedOption,
        });
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: event.target.value 
        });
    };

    ayuda = () => (
        <React.Fragment>
            <Row>
                <Col md={12} align="justify">
                    Mediante este módulo podrás agregar nuevos usuarios para el sistema. Para ello debes llenar los campos y presionar el botón <button className="btn btn-primary btn btn-xs" style={{borderWidth:1}}><i className="pe-7s-add-user"></i> Registrar</button>
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    También puedes cambiar el email de un usuario específico ingresando su correo en el campo <span className="custom-alert-success">Búsqueda de Usuarios</span>
                </Col>
            </Row>
            <Row className="custom-mt-10">
                <Col md={2}>
                    <button className="btn btn-primary btn btn-xs" style={{borderWidth:1}}><i className="fa fa-times"></i></button>
                </Col>
                <Col md={10} align="justify">
                    Este botón permite cancelar la edición para poder agregar un nuevo usuario
                </Col>
            </Row>
            <Row className="custom-mt-10">
                <Col md={2}>
                    <button className="btn btn-warning btn btn-xs" style={{borderWidth:1}}><i className="fa fa-edit"></i></button>
                </Col>
                <Col md={10} align="justify">
                    Este botón permite guardar los cambios. Esta opción cambia solamente el email del usuario.
                </Col>
            </Row>
        </React.Fragment>
    )

    register = () => (e) => {
        let { user, pass1, pass2, selectedOption } = this.state;
        let expReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;

        if(user === ""){toast.error(<div>El campo Correo Electrónico no debe estar vacío</div>,{});return null}
        if(expReg.test(user) === false){
            toast.error(<div>El campo Correo Electrónico debe tener un formato válido</div>,{});
            return null;
        }
        if(pass1 === ""){
                toast.error(<div>El campo Contraseña es obligatorio</div>,{});
            return null;
        }
        if(pass1 !== pass2){
            toast.error(<div>Las contraseñas no coinciden</div>,{});
            return null;
        }

        this.setState ({
            button: {
                Icon:"fa fa-spinner fa-spin",
                Title:"Verificando espere..."
            }
        },() => {
            RegistraUsuario (user, pass2, selectedOption.value, (resp) => {
                this.setState ({
                    button: {
                        Icon:"pe-7s-add-user",
                        Title:"Registrar"
                    },
                    selectedOption: {
                        value: '1',
                        label: 'Estudiante'
                    },
                    user:"",
                    pass1:"",
                    pass2:"",
                    selectedOptionDisabled: false,
                    pass1Disabled: false,
                    pass2Disabled: false,
                },() => {
                    toast[resp.tipo](resp.mensaje,{});
                });
            })
        });
    }

    cancelar = () => {
        statusBtn = 0;
        this.setState ({
            button: {
                Icon:"pe-7s-add-user",
                Title:"Registrar"
            },
            selectedOption: {
                value: '1',
                label: 'Estudiante'
            },
            user:"",
            pass1:"",
            pass2:"",
            string: "",
            selectedOptionDisabled: false,
            pass1Disabled: false,
            pass2Disabled: false,
        });
    }

    respuestaEditar = (resp) => {
        this.setState ({
            boton3: { Icon:"fa fa-edit", Title:""},
        }, () => {
            toast[resp.tipo](<div>{resp.mess}</div>,{});
        })
    }

    botones = () => {
        const { button, boton2, boton3 } = this.state;

        switch (statusBtn) {
            case 0:
                return (
                    <button className="btn btn-primary" id="register" onClick={this.register()} style={{borderWidth:1}}><i className= {button.Icon} style={{fontSize:16}}></i> {button.Title}</button>
                )
            case 1:
                return (
                    <div className="btn-group" role="group">
                        <button className="btn btn-primary"  disabled={boton2.disabled} onClick ={this.cancelar} title="Cancelar" style={{borderWidth: 1}}><i className={boton2.Icon}></i></button>
                        <button className="btn btn-warning"  disabled={boton3.disabled}
                        onClick={ (e) => {
                            this.setState({
                                boton3:{ Icon: "fa fa-spinner fa-spin" },
                            }, () => {
                                EditarUsuario (idUsuario, this.state.user, (resp) => { this.respuestaEditar(resp) })
                            })
                        }}
                        title="Editar este Usuario" style={{borderWidth: 1}}><i className={boton3.Icon}></i></button>
                    </div>
                )
            default:
                return (<div></div>)
        } 
    }

    contenido = () => {
        const { selectedOption, title, selectedOptionDisabled, pass1Disabled, pass2Disabled, user } = this.state;

        const options = [
            { value: '1', label: 'Estudiante' },
            { value: '2', label: 'Profesor' },
            { value: '3', label: 'Directivo' },
            { value: '4', label: 'Administratvo' },
        ];

        let help1 = (
            <Popover title="Tipo de usuario" id="u_type">
                <strong style={{color:"#1f2f6e"}}>Importante: </strong>
                Dependiendo del tipo de usuario, tendrá o no mas privilegios de uso al sistema
            </Popover>
        )

        let help2 = (
            <Popover title="Correo Electrónico" id="email">
                Introduce un <strong>Correo Electrónico</strong> válido. <br/>
                Ej: <strong style={{color:"#1f2f6e"}}>example@exampĺe.com</strong>
            </Popover>
        )

        let help3 = (
            <Popover title="Contraseña" id="pass">
                Introduce una <strong>Contraseña segura</strong>
            </Popover>
        )

        return (
            <React.Fragment>
                <Row>
                    <Col md={3} align="right">
                        Tipo de Usuario:
                    </Col>
                    <Col md={7}>
                        <Select
                            isSearchable ={false}
                            value={selectedOption}
                            onChange={this.handleChange}
                            options={options}
                            isDisabled={selectedOptionDisabled}
                        />
                    </Col>
                    <Col md={2} align="center">
                        <OverlayTrigger trigger="focus" placement="right" overlay={help1}>
                            <button className="btn btn-warning" style={{borderWidth:1}} title={title}><i className="fa fa-question-circle-o"></i></button>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row style={{marginTop:10}}>
                    <Col md={3} align="right">
                        Correo Electrónico:
                    </Col>
                    <Col md={7}>
                        <input onChange={this.cambiaValor("user")} value={user} onKeyPress={this.enterTab("pass1")} placeholder="Correo Electrónico" className="form-control"/>
                    </Col>
                    <Col md={2} align="center">
                        <OverlayTrigger trigger="focus" placement="right" overlay={help2}>
                            <button className="btn btn-warning" style={{borderWidth:1}} title={title}><i className="fa fa-question-circle-o"></i></button>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row style={{marginTop:10}}>
                    <Col md={10} align="right">
                        <Col md={5} align="right">
                            Contraseña:
                        </Col>
                        <Col md={7} style={{paddingRight: 0,}}>
                            <input type="password" id="pass1" onChange={this.cambiaValor("pass1")} disabled={pass1Disabled} onKeyPress={this.enterTab("pass2")} placeholder="Ingresa una contraseña" className="form-control"/>
                        </Col>
                        <Col md={5} align="right" style={{marginTop:10}}>
                            Repite la Contraseña:
                        </Col>
                        <Col md={7} style={{marginTop:10, paddingRight: 0,}}>
                            <input type="password" id="pass2" onChange={this.cambiaValor("pass2")} disabled={pass2Disabled} onKeyPress={this.enterTab("register")} placeholder="Repite contraseña" className="form-control"/>
                        </Col>
                    </Col>

                    <Col md={2} align="center" style={{marginTop:30}}>
                        <OverlayTrigger trigger="focus" placement="right" overlay={help3}>
                            <button className="btn btn-warning" style={{borderWidth:1}} title={title}><i className="fa fa-question-circle-o"></i></button>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <Row style={{marginTop:20}}>
                    <Col md={12} align="right">
                        {this.botones()}
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    enterTab = (next) => (e) => {if (e.which === 13) document.getElementById(next).focus();}

    enterTab2 = () => (e) => {
        if (e.which === 13){
            if (this.state.string === "") return null;

            let expReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;

            if(expReg.test(this.state.string) === false){
                toast.error(<div>El Correo Electrónico a consultar debe tener un formato válido</div>,{});
                return null;
            }

            this.setState ({
                preloader: "fa fa-spinner fa-spin"
            }, () => {
                BuscaUsuario (this.state.string, (resp) => {
                    if(resp.status === "error") {
                        toast.error(<div>El Correo Electrónico ingresado no se encuentra registrado</div>,{});
                        this.setState({
                            preloader: ""
                        })
                    }else{
                        idUsuario = resp.id;
                        let labEst = "";
                        statusBtn = 1;

                        switch (resp.tipo) {
                            case 1:
                                labEst = "Estudiante";
                                break;
                            case 2:
                                labEst = "Profesor";
                                break;
                            case 3:
                                labEst = "Directivo"
                                break;
                            default:  
                        }

                        this.setState({
                            selectedOptionDisabled: true,
                            pass1Disabled: true,
                            pass2Disabled: true,
                            preloader: "",
                            user: resp.email,
                            selectedOption: {
                                value: resp.tipo,
                                label: labEst
                            }
                        })
                    }
                })
            });
        }
    }

    render() {
        let { string, preloader } = this.state;

        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        <div className="custom-alert-success" style={{padding: 5}}>
                            <div>Búsqueda de Usuarios <i className={preloader}></i></div>
                            <input type="text" value ={string} onChange={this.cambiaValor("string")} onKeyPress={this.enterTab2()} className="form-control" placeholder="Ingresa un email para editarlo y pulsa Enter"/>
                        </div>
                        <div class="custom-mt-20">{this.contenido()}</div>
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Usuarios</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default Usuarios;


// WEBPACK FOOTER //
// ./src/views/Registros/Usuarios.jsx